import { render, staticRenderFns } from "./ProjectsDropdown.vue?vue&type=template&id=1b17505a&"
import script from "./ProjectsDropdown.vue?vue&type=script&lang=js&"
export * from "./ProjectsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports